import { Dialog, DialogContent, IconButton, Tooltip } from '@material-ui/core';
import React from 'react';
import { TutorialSlider } from './TutorialSlider';
import HelpIcon from '@mui/icons-material/Help';

export function TutorialDialog() {
  const [open, setOpen] = React.useState(false);

  return (
    <div>
      <Tooltip title="Show Tutorial">
        <IconButton onClick={() => setOpen(true)} size="small">
          <HelpIcon />
        </IconButton>
      </Tooltip>
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogContent>
          <TutorialSlider />
        </DialogContent>
      </Dialog>
    </div>
  );
}
